import styled from 'styled-components';
import { customMedia, cssDropdown, cssDropdownItem } from 'styles/utils';

import Icon from '../Icon';

export const DropdownStyled = styled.div`
  position: relative;
  display: inline-block;
  font-size: ${props => props.theme.font.size[props.size]};
`;

export const IconStyled = styled(Icon)`
  margin-right: ${props => props.theme.spacing.small};
  vertical-align: top;
`;

export const DropTrigger = styled.button(({ theme, variant }) => {
  let styleSheet = {
    '-webkit-appearance': 'none',
    display: 'flex',
    cursor: 'pointer',
    padding: `${theme.spacing.small} ${theme.spacing.default}`,
    borderRadius: theme.borderRadius.large,
    border: 'none',
    backgroundColor: 'transparent',
    color: theme.color.wfBlack,
    transition: `background-color linear 0.2s`,
    '&:hover': {
      backgroundColor: theme.color.wfGrey200,
    },
  };

  if (variant === 'outlined') {
    styleSheet = {
      ...styleSheet,
      border: `1px solid ${theme.color.wfGrey50}`,
      borderRadius: 0,
    };
  }

  return styleSheet;
});

export const Placeholder = styled.strong`
  color: ${props => props.theme.color.wfBlack};
  margin-left: ${props => props.theme.spacing.small};
`;

const GAP = 8;

export const DropMenu = styled.ul`
  display: inline-block;
  right: 0;
  top: ${({ placement }) => (placement === 'bottom' ? '100%' : 'auto')};
  bottom: ${({ placement }) =>
    placement === 'top' ? `calc(100% + ${GAP}px)` : 'auto'};
  ${cssDropdown};
  min-width: ${props => (props.autoWidth ? 'auto' : cssDropdown.minWidth)};
  ${customMedia.lessThan('medium')`
    left: 0;
  `};
`;

export const DropItem = styled.li`
  display: flex;
  align-items: center;
  ${cssDropdownItem}
`;
